import axios from 'axios';
import axiosHeader from '_common/runs/axios';

// eslint-disable-next-line import/prefer-default-export
export const getCep = cep => {
  const cepClean = cep.replace(/\D/g, '');
  const validacep = /^[0-9]{8}$/;
  if (cepClean !== '' && validacep.test(cepClean)) {
    axios.defaults.headers.common = {};
    return axios
      .get(`https://brasilapi.com.br/api/cep/v1/${cepClean}`, null)
      .then(response => {
        axiosHeader();
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  }
  return false;
};
